import React from 'react';
import { Modal, ModalFooter, ModalHeader } from 'reactstrap';
import CustomButton from '../../../components/customButton';

const DeletePortalModal = ({ isOpen, cancelCb, confirmCb }) => {
  return (
    <Modal size="lg" id="delete-portal-modal" isOpen={isOpen} fade={false} centered>
      <ModalHeader>
        Delete Portal
        <p className="subtitle">Are you sure you want to remove this portal?</p>
      </ModalHeader>

      <ModalFooter>
        <CustomButton title={'Remove'} classes="btn btn-danger" handleClick={confirmCb} />
        <CustomButton title={'Cancel'} classes={'btn btn-secondary'} handleClick={cancelCb} />
      </ModalFooter>
    </Modal>
  );
};

export default DeletePortalModal;
